<script>
import qs from 'query-string';
import { CURRENT_COUNTRY_CHANGED, emitter } from '@phoenix/event-bus';

export default {
  data() {
    const queryString = qs.parse(window.location.search, {
      arrayFormat: 'bracket',
    });
    return {
      currentCountry: window.Phoenix.currentCountry,
      currentLanguage: window.Phoenix.laravelLanguage,
      currentUserAgent: navigator.userAgent,
      serialNumber: queryString.serialNumber,
      engravedNumber: queryString.articleReference,
      countryOfResidence: queryString.countryOfResidence,
    };
  },

  created() {
    emitter.on(CURRENT_COUNTRY_CHANGED, this.onCountryChanged);
  },

  unmounted() {
    emitter.off(CURRENT_COUNTRY_CHANGED, this.onCountryChanged);
  },

  methods: {
    onCountryChanged(country) {
      this.currentCountry = country;
    },
  },
};
</script>

<template>
  <input id="country" type="hidden" name="country" :value="currentCountry" />
  <input id="pega_language" type="hidden" name="pega_language" :value="currentLanguage" />
  <input id="app" type="hidden" name="app" :value="currentUserAgent" />
  <input id="serialNumber" type="hidden" name="serialNumber" :value="serialNumber" />
  <input id="articleReference" type="hidden" name="articleReference" :value="engravedNumber" />
  <input id="countryOfResidence" type="hidden" name="countryOfResidence" :value="countryOfResidence" />
</template>
